export enum SidenavSectionIndex {
  None = -1,
  Favorites = 0,
  Pinned = 1,
  Yours = 2,
}

export enum SidenavOverflowAction {
  Favorite = `favorite`,
  Edit = `edit`,
  Delete = `delete`,
  Duplicate = `duplicate`,
  Link = `link`,
  Move = `move`,
  Share = `share`,
  Pin = `pin`,
}

export enum SidenavSectionTrackingName {
  Favorites = `favorites`,
  Pinned = `pinned`,
  Yours = `yours`,
}

export const DAYS_FOR_IS_NEW_TAG = 3;

export const CONTENT_ITEM_ATTRIBUTES = [
  `id`,
  `name`,
  `description`,
  `content_type`,
  `creator_id`,
  `creator_name`,
  `creator_email`,
  `can_view`,
  `can_update_basic`,
  `can_share`,
  `is_superadmin`,
  `allow_staff_override`,
  `pinned_date`,
  `is_favorited`,
  `can_pin`,
  `is_shared_with_project`,
] as const;

export const DASHBOARD_ITEM_ATTRIBUTES = [
  `id`,
  `title`,
  `description`,
  `creator_id`,
  `creator_name`,
  `creator_email`,
  `can_view`,
  `can_update_basic`,
  `can_share`,
  `is_superadmin`,
  `allow_staff_override`,
  `pinned_date`,
  `is_favorited`,
  `can_pin`,
  `is_shared_with_project`,
  `child_dashboards`,
  `parent_dashboard_id`,
  `generation_type`,
] as const;
